import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngxs/store';
import { lastValueFrom } from 'rxjs';
import { getTenant } from '../services/global.service';
import { UserStateSelectors } from '../../store/users-store/user.selectors';
import { GetUser } from '../../store/users-store/user.actions';

export const analyticsGuard: CanActivateFn = async (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
) => {
  const router = inject(Router);
  const store = inject(Store);

  // Non-DPP tenants are always allowed
  const tenant = getTenant();
  const isDppTenant = tenant === 'dpp';
  if (!isDppTenant) {
    return true;
  }

  // Ensure user data is available
  let user = store.selectSnapshot(UserStateSelectors.getUser);
  if (!user) {
    try {
      await lastValueFrom(store.dispatch(new GetUser()));
      user = store.selectSnapshot(UserStateSelectors.getUser);
    } catch {
      router.navigateByUrl('/dashboard');
      return false;
    }
  }

  const isAllowed = user?.subscriptionInfo?.googleAnalyticsAllowed ?? false;

  if (!isAllowed) {
    router.navigateByUrl('/dashboard');
    return false;
  }

  return true;
};
